































import Vue from 'vue'
import { ProductCategory } from '@/model/productCategory'
import BaseImage from '@/common/components/BaseImage.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'

export default Vue.extend({
  name: 'CategoryHeader',
  components:{
    BaseImage
  },
  props: {
    category: {
      type: Object as () => ProductCategory,
      required: true
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    }
  }
})
